import {
    ADMINDELETELANGUAGEMAPPING_SUCCESS,
    ADMINDELETELANGUAGEMAPPING_FAILED,
    RESET_ADMINDELETELANGUAGEMAPPING,
    LOADING_ADMINDELETELANGUAGEMAPPING,
    NETWORK_ERROR_ADMINDELETELANGUAGEMAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminDeleteLanguageMapping = () => {
    return { type: RESET_ADMINDELETELANGUAGEMAPPING };
};

const deleteLanguageMappingAdmin = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINDELETELANGUAGEMAPPING });
    await adminServices
        .post("deleteLanguageMapping", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(AdminDeleteLanguageMappingsuccess(res.data));
                    break;
                default:
                    dispatch(AdminDeleteLanguageMappingFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINDELETELANGUAGEMAPPING,
                payload: err
            });
        });
};


function AdminDeleteLanguageMappingsuccess(data) {
    return {
        type: ADMINDELETELANGUAGEMAPPING_SUCCESS,
        payload: data
    };
}
function AdminDeleteLanguageMappingFailed(data) {
    return {
        type: ADMINDELETELANGUAGEMAPPING_FAILED,
        payload: data
    };
}

export { deleteLanguageMappingAdmin, resetAdminDeleteLanguageMapping }